import { render, staticRenderFns } from "./SuperAdminDashboard.vue?vue&type=template&id=7533e122"
import script from "./SuperAdminDashboard.vue?vue&type=script&lang=js"
export * from "./SuperAdminDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7533e122')) {
      api.createRecord('7533e122', component.options)
    } else {
      api.reload('7533e122', component.options)
    }
    module.hot.accept("./SuperAdminDashboard.vue?vue&type=template&id=7533e122", function () {
      api.rerender('7533e122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/dashboard/SuperAdminDashboard.vue"
export default component.exports